import { createBrowserRouter, Navigate } from "react-router-dom";
import routes from "./routes";
import HomePage from "pages/Home";
import Layout from "layout";
import CountdownPage from "pages/Countdown";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      ...routes,
    ],
  },

  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);

export default router;
